<div class="search-list-container">
  <mat-form-field>
    <mat-chip-grid #chipGrid>
      <mat-chip-row
        *ngFor="let val of selectedValues"
        class="notranslate"
        appNoTranslate
        (removed)="remove(val)">
        {{ getOptionLabel(val) }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    </mat-chip-grid>
    <input
      *ngIf="!isMaxReached"
      matInput
      #searchInput
      placeholder="Search..."
      [matChipInputFor]="chipGrid"
      [(ngModel)]="searchText"
      (ngModelChange)="filterOptions()"
      [matAutocomplete]="auto"
      name="searchInput">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event)">
      <mat-option *ngFor="let option of filteredOptions" [value]="option" class="notranslate" appNoTranslate>
        {{ option.key }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <p class="max-reached-msg" *ngIf="isMaxReached && maxSelections">
    Máximo de seleções atingido: ({{ maxSelections }}).
  </p>
</div>
